"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/formFill/MonthLog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _rows = require('shared/services/forms/rows');
var _Header = require('./Header'); var _Header2 = _interopRequireDefault(_Header);
var _Sheet = require('./Sheet'); var _Sheet2 = _interopRequireDefault(_Sheet);
var _Signer = require('./Signer'); var _Signer2 = _interopRequireDefault(_Signer);
var _view = require('./view');


const RESULTS = ['given', 'refused', 'missed']
const WEEKDAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S']

// The initials typed for the first row prefill the next ones, for this tab.
const INITIALS_KEY = 'form-fill-initials'
let rememberedInitials = ''
const readInitials = () => {
  try { return _nullishCoalesce(sessionStorage.getItem(INITIALS_KEY), () => ( rememberedInitials)) } catch (e2) { return rememberedInitials }
}
const rememberInitials = (initials) => {
  rememberedInitials = initials
  try { sessionStorage.setItem(INITIALS_KEY, initials) } catch (e3) { /* storage blocked */ }
}









/* One row's inputs. Add row saves it at once. */
const AddRowSheet = ({ field, dayTitle, day, onAdded, onClose }) => {
  const columns = field.rows.columns
  const asks = columns.filter(c => c.type === 'text' || c.type === 'time' || c.type === 'date')
  const hasResult = columns.some(c => c.type === 'result')
  const [values, setValues] = _react.useState({})
  const [result, setResult] = _react.useState('')
  const [initials, setInitials] = _react.useState.call(void 0, readInitials)
  const [error, setError] = _react.useState.call(void 0, '')
  const [sending, setSending] = _react.useState.call(void 0, false)

  const ready = initials.trim().length >= 2 && (!hasResult || result !== '') && !sending

  const add = () => {
    setSending(true)
    setError('')
    const Values = {}
    for (const c of asks) {
      const v = _optionalChain([values, 'access', _2 => _2[c.id], 'optionalAccess', _3 => _3.trim, 'call', _4 => _4()])
      if (v) Values[c.id] = v
    }
    _client2.default.send('AddFormRow', {
      FieldID: field.id,
      Day: field.rows.mode === 'day' ? day : 0,
      Values,
      Initials: initials.trim(),
      ...(result && { Result: result }),
    })
      .then(({ Row }) => {
        rememberInitials(initials.trim())
        onAdded(Row)
      })
      .catch((err) => {
        setSending(false)
        setError(_optionalChain([err, 'optionalAccess', _5 => _5.Error]) || 'This row could not be saved. Please try again.')
      })
  }

  return (
    _react2.default.createElement(_Sheet2.default, { label: `Add ${_view.itemName.call(void 0, field)}`, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
      , _react2.default.createElement('div', { className: "form-fill--sheet-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}},  _view.itemName.call(void 0, field) , " · "  ,  dayTitle )
      , _react2.default.createElement('div', { className: "form-fill--sheet-sub", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}, "Saved as soon as you add it."      )
      ,  asks.map(c => (
        _react2.default.createElement('div', { className: "form-fill--field", key: c.id, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
          , _react2.default.createElement('label', { className: "form-fill--label", htmlFor: `form-row-${c.id}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}},  c.label )
          , _react2.default.createElement('input', {
            id: `form-row-${c.id}`,
            className: "form-fill--input",
            type: c.type === 'text' ? 'text' : c.type,
            value: _nullishCoalesce(values[c.id], () => ( '')),
            maxLength: 2000,
            onChange: e => setValues(v => ({ ...v, [c.id]: e.target.value })), __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
          )
        )
      )) 
      ,  hasResult && (
        _react2.default.createElement('div', { className: "form-fill--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
          , _react2.default.createElement('div', { className: "form-fill--label", id: "form-row-result", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, "Result")
          , _react2.default.createElement('div', { className: "form-fill--results", role: "radiogroup", 'aria-labelledby': "form-row-result", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
            ,  RESULTS.map(r => (
              _react2.default.createElement('button', {
                key: r,
                type: "button",
                role: "radio",
                'aria-checked': result === r,
                className: _classBuilder2.default.call(void 0, 'form-fill--choice', { 'form-fill--choice-on': result === r }),
                onClick: () => setResult(r), __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}

                ,  _view.resultLabel[r] 
              )
            )) 
          )
        )
      ) 
      , _react2.default.createElement('div', { className: "form-fill--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
        , _react2.default.createElement('label', { className: "form-fill--label", htmlFor: "form-row-initials", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}, "Your initials" )
        , _react2.default.createElement('input', {
          id: "form-row-initials",
          className: "form-fill--input form-fill--input-short" ,
          type: "text",
          value: initials,
          maxLength: 4,
          autoCapitalize: "characters",
          onChange: e => setInitials(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
        )
      )
      ,  error && _react2.default.createElement('div', { className: "form-fill--footer-error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}},  error ) 
      , _react2.default.createElement('button', { type: "button", className: "form-fill--primary", disabled: !ready, onClick: add, __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}, "Add row" )
    )
  )
}








/* A monthly log: one calendar with a dot per row, the chosen day's rows,
 * and one signature for the month. */
const MonthLog = ({ view, onRowAdded, onViewPage, onSigned }) => {
  const month = _react.useMemo.call(void 0, () => _view.logMonth.call(void 0, view), [view])
  const days = month.daysInMonth()
  const now = _moment2.default.call(void 0, )
  const today = now.year() === month.year() && now.month() === month.month() ? now.date() : 0
  const [chosen, setChosen] = _react.useState.call(void 0, () => today || (now.isAfter(month) ? days : 1))
  const [adding, setAdding] = _react.useState(null)
  const [signing, setSigning] = _react.useState.call(void 0, false)
  const [draft, setDraft] = _react.useState()
  const closeAdd = _react.useCallback.call(void 0, () => setAdding(null), [])
  const closeSign = _react.useCallback.call(void 0, (d) => {
    setDraft(d)
    setSigning(false)
  }, [])

  const tables = _view.rowsFields.call(void 0, view)
  const rows = _react.useMemo.call(void 0, () => _nullishCoalesce(view.Rows, () => ( [])), [view.Rows])
  const byDay = _react.useMemo.call(void 0, () => {
    const map = new Map()
    for (const row of rows) {
      const d = _view.rowDay.call(void 0, row, month)
      if (d) map.set(d, [...(_nullishCoalesce(map.get(d), () => ( []))), row])
    }
    return map
  }, [rows, month])

  const monthName = month.format('MMMM')
  const dateOf = (day) => month.clone().date(day)
  const chosenDate = dateOf(chosen)
  const dayTitle = chosen === today ? 'today' : chosenDate.format('MMM D')
  const dayHeading = chosen === today
    ? `Today, ${chosenDate.format('dddd MMM D')}`
    : chosenDate.format('dddd, MMM D')
  const tableOf = (row) => tables.find(t => t.id === row.field)
  const added = (row) => {
    onRowAdded(row)
    setAdding(null)
  }

  if (signing) {
    const summary = (
      _react2.default.createElement('table', { className: "form-fill--summary", __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}
        , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}
          ,  tables.map(t => {
            const mine = rows.filter(r => r.field === t.id)
            const refused = mine.filter(r => r.result === 'refused').length
            const missed = mine.filter(r => r.result === 'missed').length
            return (
              _react2.default.createElement('tr', { key: t.id, __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
                , _react2.default.createElement('th', { scope: "row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}},  _view.itemName.call(void 0, t) )
                , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}
                  ,  mine.length , " " ,  mine.length === 1 ? 'row' : 'rows' 
                  ,  refused > 0 && ` · ${refused} refused` 
                  ,  missed > 0 && ` · ${missed} missed` 
                )
              )
            )
          }) 
        )
      )
    )
    return (
      _react2.default.createElement(_Signer2.default, {
        view: view,
        onSigned: onSigned,
        onExit: closeSign,
        draft: draft,
        summary: summary,
        consentNote: "You can't add rows after you submit."      ,
        title: `${view.FormName} · ${monthName}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 199}}
      )
    )
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "form-fill--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}
        , _react2.default.createElement(_Header2.default, {
          title: `${view.FormName} · ${monthName}`,
          details: [_view.childName.call(void 0, view), `${rows.length} ${rows.length === 1 ? 'row' : 'rows'}`],
          onViewPage: onViewPage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}

          , _react2.default.createElement('div', { className: "form-fill--legend", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}, _react2.default.createElement('i', { className: "form-fill--dot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}} ), " Given" )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}, _react2.default.createElement('i', { className: "form-fill--dot form-fill--dot-red" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}} ), " Refused or missed"   )
          )
        )
        , _react2.default.createElement('div', { className: "form-fill--weekdays", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}
          ,  WEEKDAYS.map((d, i) => _react2.default.createElement('span', { key: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 225}},  d )) 
        )
        , _react2.default.createElement('div', { className: "form-fill--calendar", role: "group", 'aria-label': `Days of ${monthName}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}}
          ,  Array.from({ length: month.day() }, (_, i) => _react2.default.createElement('span', { key: `blank-${i}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}} )) 
          ,  Array.from({ length: days }, (_, i) => i + 1).map(day => {
            const dayRows = _nullishCoalesce(byDay.get(day), () => ( []))
            return (
              _react2.default.createElement('button', {
                key: day,
                type: "button",
                className: _classBuilder2.default.call(void 0, 'form-fill--day', { 'form-fill--day-on': day === chosen, 'form-fill--day-today': day === today }),
                'aria-pressed': day === chosen,
                'aria-label': `${dateOf(day).format('MMM D')}, ${dayRows.length} ${dayRows.length === 1 ? 'row' : 'rows'}`,
                onClick: () => setChosen(day), __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}

                , _react2.default.createElement('span', { className: "form-fill--day-number", __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}},  day )
                , _react2.default.createElement('span', { className: "form-fill--day-dots", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}}
                  ,  dayRows.slice(0, 6).map(row => (
                    _react2.default.createElement('i', { key: row.id, className: _classBuilder2.default.call(void 0, 'form-fill--dot', { 'form-fill--dot-red': row.result === 'refused' || row.result === 'missed' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}} )
                  )) 
                )
              )
            )
          }) 
        )
        , _react2.default.createElement('div', { className: "form-fill--day-heading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}},  dayHeading )
        , _react2.default.createElement('ul', { className: "form-fill--rows", __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}
          ,  (_nullishCoalesce(byDay.get(chosen), () => ( []))).map(row => {
            const table = tableOf(row)
            const other = (_nullishCoalesce(_optionalChain([table, 'optionalAccess', _6 => _6.rows, 'optionalAccess', _7 => _7.columns]), () => ( [])))
              .filter(c => _rows.isRowValueColumn.call(void 0, c) && row.values[c.id])
              .map(c => row.values[c.id])
            const stamp = row.result === 'refused' ? ' R' : row.result === 'missed' ? ' M' : ''
            const addedAt = _moment2.default.call(void 0, row.added)
            return (
              _react2.default.createElement('li', { key: row.id, className: "form-fill--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 260}}
                , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'form-fill--stamp', { 'form-fill--stamp-red': !!stamp }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}},  row.initials ,  stamp )
                , _react2.default.createElement('span', { className: "form-fill--row-main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 262}}
                  , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 263}},  table ? _view.itemName.call(void 0, table) : '' ,  row.result && ` · ${_view.resultLabel[row.result]}` )
                  ,  other.length > 0 && _react2.default.createElement('span', { className: "form-fill--row-sub", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}},  other.join(' · ') ) 
                )
                , _react2.default.createElement('span', { className: "form-fill--row-added", __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}, "Added "
                   ,  addedAt.isSame(now, 'day') ? addedAt.format('h:mm A') : addedAt.format('MMM D, h:mm A') 
                )
              )
            )
          }) 
        )
        ,  tables.map(t => (
          _react2.default.createElement('button', { key: t.id, type: "button", className: "form-fill--add", onClick: () => setAdding(t), __self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}
            , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}, "+")
            ,  t.rows.mode === 'next' || chosen === today ? `Add ${_view.itemName.call(void 0, t)}` : `Add ${_view.itemName.call(void 0, t)} for ${chosenDate.format('MMM D')}` 
          )
        )) 
      )
      , _react2.default.createElement('div', { className: "form-fill--footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}}
        , _react2.default.createElement('button', { type: "button", className: "form-fill--secondary", onClick: () => setSigning(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}, "Sign and submit"  )
      )
      ,  adding && (
        _react2.default.createElement(AddRowSheet, { field: adding, dayTitle: dayTitle, day: chosen, onAdded: added, onClose: closeAdd, __self: this, __source: {fileName: _jsxFileName, lineNumber: 284}} )
      ) 
    )
  )
}

exports. default = MonthLog
